module.exports = __webpack_public_path__ + "img/warning_webshop.69d457e.svg";